import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { groupImportSchema, groupImportListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions, updateGroupImport } from 'app/ducks/groupImports/actions';
import { GroupImportsActionTypes as types } from 'app/ducks/groupImports/types';

function* createGroupImportSaga(action): any {
  yield put(sagaActions.createGroupImportPending(action.payload.data));
  const [error, response] = yield (yield TeammoApi(yield select())).groupImports.create(
    action.payload.data,
  );

  if (response) {
    const normalizedResponse = normalize(response, groupImportSchema);
    const payload = {
      id: response.data.id,
      status: 'processing',
    };
    yield put(updateGroupImport(payload));
    yield put(sagaActions.createGroupImportSuccess(normalizedResponse));
    // history.push(
    //   `/connections/${action.payload.staticData['connection-id']}/runs/${response.data.id}`,
    // );
    if (action.payload?.redirect !== undefined) {
      action.payload.redirect(response.data.connectionRun?.id);
    }
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createGroupImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateGroupImportSaga(action): any {
  yield put(sagaActions.updateGroupImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationDataImports.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, groupImportSchema);

    yield put(sagaActions.updateGroupImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateGroupImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getGroupImportSaga(action): any {
  yield put(sagaActions.getGroupImportPending());
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationDataImports.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, groupImportSchema);
    yield put(sagaActions.getGroupImportSuccess(normalizedResponse));
    return normalizedResponse.entities.groupImports[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getGroupImportFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllGroupImportsSaga(action): any {
  yield put(
    sagaActions.getAllGroupImportsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.groupImports.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).groupImports.list(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, groupImportListSchema);

    yield put(
      sagaActions.getAllGroupImportsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllGroupImportsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createGroupImportSagaWatcher(): any {
  yield takeLatest(types.CREATE_GROUP_IMPORT_REQUESTED, createGroupImportSaga);
}

function* updateGroupImportSagaWatcher(): any {
  yield takeLatest(types.UPDATE_GROUP_IMPORT_REQUESTED, updateGroupImportSaga);
}

function* getGroupImportSagaWatcher(): any {
  yield takeEvery(types.GET_GROUP_IMPORT_REQUESTED, getGroupImportSaga);
}

function* getAllGroupImportsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_GROUP_IMPORTS_REQUESTED,
    getAllGroupImportsSaga,
  );
}

export default function* root(): any {
  yield all([
    createGroupImportSagaWatcher(),
    updateGroupImportSagaWatcher(),
    getGroupImportSagaWatcher(),
    getAllGroupImportsSagaWatcher(),
  ]);
}
